/**
 * Guarda datos en wallet.dat (localStorage)
 * @param {string} key - Clave para guardar
 * @param {*} value - Valor a guardar (se convierte a string si no lo es)
 * @throws {Error} Si falla el guardado
 */
export const saveToWalletDat = async (key, value) => {
  try {
    // Validación especial para cryptoWallet
    if (key === 'cryptoWallet') {
      if (typeof value !== 'string') {
        console.warn('cryptoWallet no es string, convirtiendo...', { type: typeof value, value });
        value = JSON.stringify(value);
      }
      
      // Validación adicional para el formato
      if (!value || value.length < 10) {
        throw new Error('Datos de wallet inválidos');
      }
    }

    // Obtener datos existentes
    const walletData = JSON.parse(localStorage.getItem('wallet.dat') || '{}');
    
    // Actualizar datos
    walletData[key] = value;
    
    // Guardar en localStorage
    localStorage.setItem('wallet.dat', JSON.stringify(walletData));
    
    // Verificación de que se guardó correctamente
    const savedValue = JSON.parse(localStorage.getItem('wallet.dat'))[key];
    if (savedValue !== value) {
      throw new Error('No se pudo verificar el guardado');
    }
  } catch (error) {
    console.error('Error saving to wallet.dat:', { key, value, error });
    throw new Error(`Failed to save ${key} to wallet.dat: ${error.message}`);
  }
};

/**
 * Obtiene datos de wallet.dat (localStorage)
 * @returns {object} - Todos los datos de wallet.dat
 */
export const getFromWalletDat = async () => {
  try {
    const walletData = JSON.parse(localStorage.getItem('wallet.dat') || '{}');
    
    // Validación especial para cryptoWallet
    if (walletData.cryptoWallet && typeof walletData.cryptoWallet !== 'string') {
      console.warn('cryptoWallet no es string, convirtiendo...');
      walletData.cryptoWallet = JSON.stringify(walletData.cryptoWallet);
    }
    
    return walletData;
  } catch (error) {
    console.error('Error reading from wallet.dat:', error);
    return {};
  }
};

/**
 * Limpia todos los datos de wallet.dat
 * @throws {Error} Si falla la limpieza
 */
export const clearWalletDat = async () => {
  try {
    localStorage.removeItem('wallet.dat');
    
    // Verificar que se eliminó
    if (localStorage.getItem('wallet.dat') !== null) {
      throw new Error('No se pudo limpiar wallet.dat');
    }
  } catch (error) {
    console.error('Error clearing wallet.dat:', error);
    throw new Error('Failed to clear wallet.dat: ' + error.message);
  }
};